export default __webpack_public_path__ + "static/media/trash.8eca84e7.svg";